import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { environment } from '../../../environments/environment';
import { AnalyticsService } from '../../shared/services/analytics.service';

@Component({
  selector: 'app-mobile-app-page',
  standalone: true,
  imports: [CommonModule, RouterModule, MatButtonModule, MatIconModule, MatCardModule],
  templateUrl: './mobile-app-page.component.html',
  styleUrl: './mobile-app-page.component.scss'
})
export class MobileAppPageComponent {
  private readonly analytics = inject(AnalyticsService);

  readonly iosAppStoreUrl = environment.iosAppStoreUrl?.trim() ?? '';
  readonly appIconSrc = '/img/membertrace-app-icon.png';

  readonly sharedBullets = [
    'Your members access your organization in one shared app experience.',
    'Your branding carries through web and mobile with no separate app build, store submission, or maintenance.',
    'Members who belong to multiple MemberTrace communities still use the same app, reducing friction.'
  ];

  readonly customBullets = [
    'A fully owned presence: your name, icon, and listings in the App Store and Google Play.',
    'White-glove delivery—UX, releases, and support through store review and ongoing updates.',
    'Enterprise-scoped: we align branding, release planning, and implementation with your organization\'s goals.'
  ];

  onAppStoreClick(): void {
    this.analytics.trackCtaClick('mobile-app-app-store');
  }
}
